import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import AddPortfolioForm from '../../../../components/PortfolioForm';

import {
    fetchFundTypes,
    fetchStates,
    fetchCountries
} from '../../../../../../services/redux/commonData/actions';

import {
    addNewPortfolio,
    updateAddNewPortfolioPayload,
    handleAddPortfolioVisibility
} from '../../../../../../services/redux/employee/portfolio/actions';
import { formInputValidation } from '../../../../../../services/helper/form-helper';

class AddPortfolio extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    componentDidMount() {
        let { fetchFundTypes, fetchStates, fetchCountries } = this.props;
        fetchFundTypes();
        fetchStates();
        fetchCountries();
    }

    onSubmitClick = () => {
        let {
            portfolio,
            addNewPortfolio,
            handleAddPortfolioVisibility,
            parentTrust
        } = this.props;
        let payload = {
            ...portfolio.addNewPortfolio,
            trustId: parentTrust.value
        };
        if (formInputValidation(this.formRef.current)) {
            addNewPortfolio(payload).then(response => {
                if (response.status === 200) {
                    handleAddPortfolioVisibility(false);
                }
            });
        }
    };

    onCancelClick = () => {
        let { handleAddPortfolioVisibility } = this.props;
        handleAddPortfolioVisibility(false);
    };

    render() {
        let {
            portfolio,
            commonData,
            updateAddNewPortfolioPayload
        } = this.props;
        let submitButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSubmitClick}
            >
                Submit
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [submitButton, cancelButton];

        return (
            <div role="tabpanel" className="panel col-md-6 mb">
                <Tabs defaultActiveKey={1} id="tabID">
                    <Tab eventKey={1} title="Add Portfolio">
                        <Panel showFooter footerComponents={buttonList}>
                            <div>
                                <AddPortfolioForm
                                    portfolioData={portfolio.addNewPortfolio}
                                    fundTypeList={commonData.fundTypes}
                                    updatePortfolioData={
                                        updateAddNewPortfolioPayload
                                    }
                                    countryList={commonData.countries}
                                    stateList={commonData.states}
                                    formRef={this.formRef}
                                />
                            </div>
                        </Panel>
                    </Tab>
                </Tabs>
                {portfolio.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    portfolio: state.employee.portfolio,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            addNewPortfolio,
            updateAddNewPortfolioPayload,
            handleAddPortfolioVisibility,
            fetchFundTypes,
            fetchStates,
            fetchCountries
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AddPortfolio));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/NewRequest/screens/AddPortfolio/index.js